import { CloseCircleOutlined, LeftOutlined } from '@ant-design/icons';
import { Col, Divider, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Card from '~/components/Card/Card';
import LanguageSelect from '~/components/forms/LanguageSelect/LanguageSelect';
import LegacyWrapper from '~/components/Legacy/LegacyWrapper';
import { Link, Text, Title } from '~/components/Typo/Typo';
import { HOME_ROUTE } from '~/routing/routes';
import { FontWeight } from '~/theme/constants';

import './AbandonedPage.scss';

const AbandonedPage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleBackToHome = () => {
    history.push(HOME_ROUTE());
  };

  return (
    <div className="abandoned-page">
      <Row justify="center">
        <Col lg={8} sm={24} md={12} xs={24}>
          <Card slightlyRounded className="abandonedPage-body-content">
            <div className="header">
              <Row justify="space-between">
                <div className="left-side-header">
                  <div className="title-wrapper">
                    <Title className="title-label" level={4} weight={FontWeight.LIGHT}>
                      {t('abandonedPage:title')}
                    </Title>
                  </div>
                </div>
                <div className="right-side-header">
                  <LanguageSelect className="language-abandoned-page" />
                </div>
              </Row>
            </div>
            <Divider />
            <div className="content">
              <div className="icon-wrapper" role="img" aria-label={t('abandonedPage:title')}>
                <CloseCircleOutlined className="abandoned-icon" aria-hidden />
              </div>
              <div className="message-block">
                <Text className="message-text">{t('abandonedPage:message')}</Text>
              </div>
              <Row justify="center">
                <Link className="back-button" onClick={handleBackToHome}>
                  <LeftOutlined className="back-icon" />
                  <Text>{t('abandonedPage:backToHome')}</Text>
                </Link>
              </Row>
            </div>
          </Card>
        </Col>
      </Row>
      <div className="abandoned-page-footer">
        <Row justify="center">
          <LegacyWrapper label={t('home:footer:securedBy')} />
        </Row>
      </div>
    </div>
  );
};

export default AbandonedPage;
